import { Pipe, PipeTransform } from '@angular/core';

import { ChatMemberInfo } from '../chat.models';

@Pipe({
  name: 'userStatusDescription',
})
export class UserStatusDescriptionPipe implements PipeTransform {
  /**
   * @example
   * `isGroupChat=true`
   * ```
   * Unavailable
   *
   * Alice
   * 💬 In a meeting
   *
   * Bob
   *
   * Charlie
   * 💬 Out for lunch
   * ```
   *---
   * `isGroupChat=false`
   * `forceShowUserName=true`:
   * ```
   * Alice
   * 💬 In a meeting
   * ```
   * ---
   * ```
   * Unavailable
   * Alice
   * 💬 In a meeting
   * ```
   * `descriptionOnly=true`:
   * ```
   * 💬 In a meeting
   * ```
   */
  transform(
    chatMemberInfo: ChatMemberInfo[],
    isGroupChat = false,
    forceShowUserName = false,
    descriptionOnly = false,
  ): string | undefined {
    if (!chatMemberInfo.length) {
      return undefined;
    }

    if (isGroupChat) {
      const usersOnlyWithDescription = chatMemberInfo
        .filter((member) => member.statusDescription && !member.status)
        .map((member) => `${member.name || member.email}\n💬 ${member.statusDescription}`);
      const usersWithStatus = (
        [...new Set(chatMemberInfo.map((member) => member?.status))].filter(Boolean) as string[]
      )
        .sort((a, b) => a.localeCompare(b) || 0)
        .map((status) => {
          const members = chatMemberInfo
            .filter((member) => member?.status === status)
            .map((member) => {
              const name = member.name || member.email;
              const description = member.statusDescription
                ? '\n💬 ' + member.statusDescription
                : '';
              return `${name}${description}`;
            });
          return `${status}\n\n${members.join('\n\n')}`;
        })
        .join('\n\n');

      return [...usersOnlyWithDescription, usersWithStatus].filter(Boolean).join('\n\n');
    }

    const resultLines = [
      descriptionOnly ? '' : chatMemberInfo[0]?.status || '',
      forceShowUserName ? chatMemberInfo[0]?.name || chatMemberInfo[0]?.email : '',
      chatMemberInfo[0]?.statusDescription ? '💬 ' + chatMemberInfo[0].statusDescription : '',
    ];

    return resultLines.filter(Boolean).join('\n');
  }
}
